import React from 'react';
import { Info } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

/**
 * Reusable small info icon with a tooltip.
 * Use it next to a button/label to explain what it does.
 * Usage: <InfoTooltip text="Courte explication en 1-2 phrases." />
 */
export default function InfoTooltip({ text, className = '', size = 14 }) {
  if (!text) return null;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={(e) => e.stopPropagation()}
            className={`inline-flex items-center justify-center text-gray-400 hover:text-gold transition-colors cursor-help ${className}`}
            aria-label="Info"
            data-testid="info-tooltip-trigger"
          >
            <Info size={size} />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          className="max-w-xs bg-navy text-white text-xs leading-relaxed p-3 shadow-xl border-0"
          data-testid="info-tooltip-content"
        >
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
